import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { LabelM, LabelXS } from 'atoms/typography';
import { Dots } from 'atoms/ui/Dots';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useIntlContext } from 'contexts/intl';
import { useFiatBalance } from 'hooks/wallets/useFiatBalance';
import { faFiatCurrencySymbols } from 'lib/fiat';

type Props = { collapsed?: boolean };

export const FiatBalance = ({ collapsed }: Props) => {
  const { formatNumber } = useIntlContext();
  const { currentUser } = useCurrentUserContext();
  const { fiatCurrency, availableBalanceWithCurrencySymbol, availableBalance } =
    useFiatBalance({
      notation: 'compact',
      compactDisplay: 'short',
    });

  const hideBalance = currentUser?.userSettings?.hideBalance;

  if (collapsed) {
    return (
      <Vertical gap={0.5} center>
        <FontAwesomeIcon icon={faFiatCurrencySymbols[fiatCurrency]} size="1x" />
        <LabelXS bold>
          {hideBalance ? (
            <Dots count={3} size="small" />
          ) : (
            formatNumber(availableBalance, {
              currency: fiatCurrency,
              notation: 'compact',
              compactDisplay: 'short',
            })
          )}
        </LabelXS>
      </Vertical>
    );
  }

  return hideBalance ? (
    <Horizontal center>
      <FontAwesomeIcon icon={faFiatCurrencySymbols[fiatCurrency]} size="1x" />
      <Horizontal gap={0.5}>
        <Dots count={3} size="small" />
      </Horizontal>
    </Horizontal>
  ) : (
    <LabelM bold>{availableBalanceWithCurrencySymbol}</LabelM>
  );
};
